import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CustomModal } from '../../../utils/components/CustomModal';
import axiosTenant from '../../../store/utils/tenant';

import {
  updateInstance
} from "../../../store/actions";

import {
  notification
} from '../../../store/actions';

import DuplicateIcon from '../../../assets/svg/DuplicateIcon';
import RedirectIcon from '../../../assets/svg/RedirectIcon';
import ShareIcon from '../../../assets/svg/ShareIcon';
import Tooltip from '../../../assets/svg/Tooltip';

import Loader from '../../../assets/components/loader';

import { isDevEnv } from '../../../constants/defaultValues';

const InstanceModal = ({
  changeModalState,
  instance,
  loading,
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tooltip, setTooltip] = useState(null);
  const [checkingDomain, setCheckingDomain] = useState(false)
  const [instanceData, setInstanceData] = useState({
    name:{
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    admin:{
      value: "",
      focused: false,
      required: false,
      error: ""
    },
    events:{
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    description:{
      value: "",
      focused: false,
      required: false,
      error: ""
    }
  })

  useEffect(() => {
    if (Object.keys(instance).length > 0) {
      let currentKeys = Object.keys(instance)
      currentKeys.map((key) => {
        if (instanceData.hasOwnProperty([key])) {
          setInstanceData(prevInstance => ({
            ...prevInstance,
            [key]: {
              ...prevInstance[key],
              value: instance[key],
              focused: true,
              error: prevInstance[key].required ? validate(key, instance[key]) : ""
            }
          }))
        }else if(key === "urls"){
          let urlKeys = Object.keys(instance[key]);
          if (urlKeys.length > 0){
            urlKeys.map((urlkey) => {
              setInstanceData(prevInstance => ({
                ...prevInstance,
                [urlkey]: {
                  ...prevInstance[urlkey],
                  value: instance.urls[urlkey].replace(".marquet.events", "").replace(".marquet.app", ""),
                  focused: true,
                  error: instanceData[urlkey].required ? validate(urlkey, instance.urls[urlkey].replace(".marquet.events", "").replace(".marquet.app", "")) : ""
                }
              }))
            })
          }
        }
      })
    }
  },[instance])

  const handleInputChange = (ev) => {
    setInstanceData(prevInstance => ({
      ...prevInstance,
      [ev.target.name]: {
        ...prevInstance[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: prevInstance[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleOnfocus = (ev) => {
    setInstanceData(prevInstance => ({
      ...prevInstance,
      [ev.target.name]: {
        ...prevInstance[ev.target.name],
        focused: true,
        error: prevInstance[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  async function checkInstanceDomain(ev) {
    let value = ev.target.value;
    if (value.length > 2 && value !== instance.urls.events.replace(".marquet.events", "").replace(".marquet.app", "")) {
      try {
        setCheckingDomain(true)
        let response = await axiosTenant.get(`/check-domain?domain=${value}`);
        if (response && response.data && response.data.success && response.data.available) {
          response.data.value = value;
          setInstanceData(prevInstance => ({
            ...prevInstance,
            [ev.target.name]: {
              ...prevInstance[ev.target.name],
              value: ev.target.value,
              focused: true,
              error: ""
            }
          }))
          setCheckingDomain(false)
        } else if (response && response.data && response.data.success && !response.data.available) {
          response.data.value = value;
          setInstanceData(prevInstance => ({
            ...prevInstance,
            [ev.target.name]: {
              ...prevInstance[ev.target.name],
              value: ev.target.value,
              focused: true,
              error: response.data.message
            }
          }))
          setCheckingDomain(false)
          return response.data
        }
      } catch (e) {
        dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
        setCheckingDomain(false)
        console.log("Error:", e)
      }
    }
  }

  const validate = (name, value) => {
    switch (name) {
      case ("name"):
        if (value.length === 0) {
          return "Virtual space name is required"
        } else if (value.length < 3) {
          return "Virtual space name must be longer"
        } else if (value.length > 25) {
          return "Virtual space name must be shorter"
        } else {
          return ""
        }
      case ("events"):
        if (value.length === 0) {
          return "Custom domain is required"
        } else if (value.length < 3) {
          return "Custom domain must be longer"
        } else if (value.length > 25) {
          return "Custom domain must be shorter"
        } else if (!/(^[a-z][a-z0-9-]+$)/.test(value)) {
          return "Only lowercase letters, numbers and hyphens are accepted."
        } else {
          return ""
        }
      default:
        return ""
    }
  }

  const inputStatus = (key) => {
    if (instance && instance.length > 0 && instance[key].focused) {
      if (instance[key].error === "") {
        return "input--group input--success"
      } else {
        return "input--group input--error"
      }
    } else {
      return "input--group"
    }
  }

  const copyUrl = (url) =>{
    navigator.clipboard.writeText(url);
    dispatch(notification({ title: `Url has been copied`, message: `${url}`, type: `info` }));
  }

  const redirectInstance = (url) => {
    window.open(`https://${url}`, '_blank');
  }

  const updateVirtualSpace = (ev) => {
    ev.preventDefault();
    let data = {
      name: instanceData.name.value,
      description: instanceData.description.value,
      customDomain: isDevEnv ? `${instanceData.events.value}.marquet.dev` : `${instanceData.events.value}.marquet.events`
    }
    dispatch(updateInstance({data:data, instanceId: instance.id}));
  }

  const changeSubscription = () =>{
    changeModalState()
    navigate(`/changeSubscription/${instance.chargebeePurchaseId}`)
  }

  const openTooltip = (ev, value) => {
    setTooltip(value)
  }

  function disabledSubmit() {
    if (checkingDomain) {
      return true
    }
    let keys = Object.keys(instance)
    for (let i = 0; i < keys.length; i++) {
      if (instance[keys[i]].required) {
        if (instance[keys[i]].focused && instance[keys[i]].error !== "") {
          return true
        } else if (!instance[keys[i]].focused) {
          return true
        }
      }
    }
    return false
  }

  return (
    <CustomModal
      modalTitle={`${(instance && instance.name) ? instance.name :""} - Created on ${(instance && instance.createdAt)? instance.createdAt.slice(0, (instance.createdAt.length - 3)):""}`}
      changeModalState={changeModalState}
      onSave={ev => updateVirtualSpace(ev)}
      background="#EDF7FF"
      width="80vw"
      height="95vh"
      twoColumnForm={true}
      footer={true}
      centerFooter={true}
      disableSubmitButton={disabledSubmit()}
      submitButtonLabel="Save"
      cancelButton={false}
      loading={loading}
    >
      <div className="marquet--form--group">
        <div className={inputStatus("name")} style={{background:"#FFFFFF"}}>
          <label>
            VIRTUAL SPACE NAME<b> *</b>
          </label>
          <input
            name="name"
            type="text"
            maxLength={50}
            onChange={ev => handleInputChange(ev)}
            onFocus={ev => handleOnfocus(ev)}
            value={instanceData.name.value ? instanceData.name.value:""} />
        </div>
        <div className="invalid--feedback">{instanceData.name.error}</div>
      </div>
      <div className="marquet--form--group"></div>
      <div className="marquet--form--group">
        <div className={inputStatus("name")} style={{ background: "#FFFFFF" }}>
          <div>
            <label>
              ADMINISTRATOR DOMAIN<b> * </b>
              <div className="tooltip--container" onMouseOver={ev => { openTooltip(ev, 1) }} onMouseOut={ev => { openTooltip(ev, null) }} >
                <Tooltip/>
                <div className={tooltip === 1 ? "tooltip" : "tooltip tooltip--collapse"}>
                  <div className="tooltip--message">
                    This is the address of the Marquet administrator, where event administrators can create and manage their events.
                    This is a non-editable domain.
                  </div>
                </div>
              </div>
            </label>
            <div>
              <div onClick={ev => copyUrl(instance.urls.admin)}>
                <DuplicateIcon />
              </div>
              <div onClick={ev => redirectInstance(instance.urls.admin)}>
                <RedirectIcon />
              </div>
              {/*<ShareIcon/>*/}
            </div>
          </div>
          <input
            name="name"
            type="text"
            maxLength={50}
            onChange={ev => handleInputChange(ev)}
            onFocus={ev => handleOnfocus(ev)}
            value={instanceData.admin.value ? instanceData.admin.value:""}
            disabled
            />
        </div>
        <div className="invalid--feedback">{instanceData.admin.error}</div>
      </div>
      <div className="marquet--form--group">
        <div className={inputStatus("name")} style={{ background: "#FFFFFF" }}>
          <div>
            <label>
              CUSTOMER SIDE DOMAIN<b> * </b>
              <div className="tooltip--container" onMouseOver={ev => { openTooltip(ev, 2) }} onMouseOut={ev => { openTooltip(ev, null) }} >
                <Tooltip/>
                <div className={tooltip === 2 ? "tooltip" : "tooltip tooltip--collapse"}>
                  <div className="tooltip--message">
                    This is your event portal domain, where your company events will be listed. This is a different address from the registration micro-site that will be created as part of the event creation process.
                  </div>
                </div>
              </div>
            </label>
            <div>
              <div onClick={ev => copyUrl(instance.urls.events)}>
                <DuplicateIcon />
              </div>
              <div onClick={ev => redirectInstance(instance.urls.events)}>
                <RedirectIcon />
              </div>
              {/*<ShareIcon/>*/}
            </div>
          </div>
          <input
            name="events"
            type="text"
            maxLength={50}
            onChange={ev => handleInputChange(ev)}
            onFocus={ev => handleOnfocus(ev)}
            onBlur={ev => checkInstanceDomain(ev)}
            value={instanceData.events.value ? instanceData.events.value : ""}
            disabled={checkingDomain} />
        </div>
        {checkingDomain && <div className="info--feedback">Checking if domain already exist... <Loader size="xs" /></div>}
        {!checkingDomain && <div className="invalid--feedback">{instanceData.events.error}</div>}
      </div>
      <div className="marquet--form--group form--group--row">
        <div className={inputStatus("name")} style={{ height: "auto", background: "#FFFFFF" }}>
          <label>
            DESCRIPTION
          </label>
          <textarea
            name="description"
            maxLength={150}
            rows={4}
            onChange={ev => handleInputChange(ev)}
            onFocus={ev => handleOnfocus(ev)}
            value={instanceData.description.value?instanceData.description.value:""} />
        </div>
        <div className="invalid--feedback">{instanceData.description.error}</div>
      </div>
      <div className="marquet--form--group form--group--row">
        <div className="custom--links cancel--modal--link" onClick={ev => changeSubscription()}>
          Select a different package
        </div>
      </div>
    </CustomModal>
  )

}

export default InstanceModal;